<template>
  <div>
    <el-cascader v-model="result"
                  clearable
                 filterable
                 :props="props"
                 ref="cascaderRef"
                 :style="{width: width || '100%'}"
                 :disabled="disabled"
                 @change="handleChange"
                 v-if="updateCascader">
    </el-cascader>
  </div>
</template>

<script>
import axios from 'axios'
  export default {
    name: "region",
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      separator: {
        type: String,
        default: '/'
      },
      levelType: {
        type: Number,
        default: 2
      },
      value: {
        type: Array,
        default: () => {
          return []
        }
      },
      dataType: {
        type: String,
        default: 'array'
      },
      change: Function,
      prop: String,
      skipType: undefined,
      skipValue: String
    },
    data() {
    //   const that = this;
      return {
        loading: false,
        optionSearch: [],
        props:{},
        result: [],
        countryId: 100000,
        level: null,
        updateCascader: true, // 更新cascader数据不回显问题
      }
    },
    created() {
      this.setValOptions(this.countryId)
    },
    watch: {
      'value': {
        handler(val) {
          if(!val || (val && !val.length)) {
            this.result = []
          }else {
            this.result = val.map(item=>{return item.id})
          }
          if(this.change && typeof(this.change)=='function') this.change({value: val, column: this})
        },
        immediate: true
      },
      'levelType'() {
        this.updateCascader = false
        setTimeout(() => {
          this.updateCascader = true
        })
        this.setValOptions(this.countryId)
      },
      'countryId'(val) {
        this.updateCascader = false
        setTimeout(() => {
          this.updateCascader = true
        })
        this.setValOptions(val)
      },
    },
    methods: {
      setValOptions (val) {
        this.props = {
            lazy: true,
            lazyLoad: (node,resolve) => {
                const { level } = node;
                const { label } = node;
                let axiosUrl
                if(window.location.href.includes('test') || window.location.href.includes('localhost') || window.location.href.includes('medon')) {
                  axiosUrl = 'https://apigateway.medon.com.cn/api/material/customForm/getMedsciAddress'
                }else {
                  axiosUrl = 'https://apigateway.medsci.cn/api/material/customForm/getMedsciAddress'
                }
                axios.post(axiosUrl, {
                    levelType: level+1,
                    parentId: node.data ? node.data.value : val
                }).then(response => {
                    if(response.data.status == 200){
                       let nodes = response.data.data.map(item => {
                        return {
                            value: item.id,
                            label: item.name,
                            leaf: level >= this.levelType
                        }
                      })
                      resolve(nodes)
                    } else {
                      let nodes = [{
                        value: -1,
                        label:label,
                        leaf: true
                      }]
                      resolve(nodes)
                    }
                })
            }
        }
      },
      handleChange() {
        let nodeContent = this.$refs['cascaderRef'].getCheckedNodes()
        let pathNodes = nodeContent && nodeContent.length > 0 && nodeContent[0] ? nodeContent[0].pathNodes : []
        let params = pathNodes.map(v => {
            return {
                id: v.value,
                name: v.label
            }
        })
        console.log(this.result)
        this.$emit('input', params)
      }
    }
  }
</script>
